import React, { FC, ReactNode } from 'react';
import { isNikeoneEnabled } from './index';

interface RequiresNikeoneProps {
    fallback?: ReactNode | null;
}
export const RequiresNikeone: FC<RequiresNikeoneProps> = ({ children, fallback = null }) => {
    if (!isNikeoneEnabled) {
        return <>{fallback}</>;
    }
    return <>{children}</>;
};
